import * as React from 'react';

import { cn } from '@/utils/utils';

export interface InputProps extends React.ComponentProps<'input'> {}

const onWheelHandler = (e: React.WheelEvent<HTMLInputElement>) => {
  const input = e.currentTarget;
  const wasFocused = document.activeElement === input;
  input.blur();
  wasFocused &&
    setTimeout(() => {
      input.focus();
    }, 10);
};

const Input = ({ className, type, ...props }: InputProps) => {
  return (
    <input
      data-slot="input"
      type={type}
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      // ignore desktop broser default behavior of capturing scroll to change numeric values
      onWheel={type === 'number' ? onWheelHandler : undefined}
      {...props}
    />
  );
};
Input.displayName = 'Input';

export { Input };
